import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import YearSpecificTranslationPlugin from './utils/i18nMiddleware';

const hash = new Date().getTime();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(YearSpecificTranslationPlugin)
  .init({
    fallbackLng: 'vi',
    lng: localStorage.getItem('i18nextLng') ?? 'vi',
    debug: true,

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?hash=${hash}`,
    },
    interpolation: {
      escapeValue: false,
    },
    postProcess: ['yearSpecificTranslation'],
  });

export default i18n;
